/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-22 14:31:09
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-09-28 10:02:48
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelMultiLanguageSelect/index.ts
 */
import { isPrimaryLanguage } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import { getState } from 'src/store';

enum EnumMultiLanguageType {
  SalesChannelContent = 'SalesChannelContent',
  SalesChannelProduct = 'SalesChannelProduct',
  SalesChannelCollection = 'SalesChannelCollection',
  SalesChannelLegalPage = 'SalesChannelLegalPage',
  SalesChannelTermsCondition = 'SalesChannelTermsCondition',
  SalesChannelSettingsCookies = 'SalesChannelSettingsCookies',
  SalesChannelSettingsCheckout = 'SalesChannelSettingsCheckout',
  SalesChannelMaintenancePage = 'SalesChannelMaintenancePage',
  SalesChannelSettingsPayment = 'SalesChannelSettingsPayment',
  SalesChannelDiscountsGiftPurchase = 'SalesChannelDiscountsGiftPurchase',
  SalesChannelDiscountsDirectDiscount = 'SalesChannelDiscountsDirectDiscount',
  SalesChannelDiscountsVoucher = 'SalesChannelDiscountsVoucher',
  SalesChannelDiscountsSubscriptionBuy = 'SalesChannelDiscountsSubscriptionBuy',
  SalesChannelSettingsLogistics = 'SalesChannelSettingsLogistics',
  SalesChannelProductPromotionTag = 'SalesChannelProductPromotionTag',
}

const urlParamsKey = {
  [EnumMultiLanguageType.SalesChannelContent]: 'contentUuid',
  [EnumMultiLanguageType.SalesChannelProduct]: 'salesChannelProductUuid',
  [EnumMultiLanguageType.SalesChannelLegalPage]: 'legalPageUuid',
  [EnumMultiLanguageType.SalesChannelTermsCondition]: 'TcUuid',
  [EnumMultiLanguageType.SalesChannelSettingsCookies]: 'uuid',
  [EnumMultiLanguageType.SalesChannelSettingsCheckout]: 'uuid',
  [EnumMultiLanguageType.SalesChannelCollection]: 'collectionsUuid',
  [EnumMultiLanguageType.SalesChannelMaintenancePage]: 'uuid',
  [EnumMultiLanguageType.SalesChannelSettingsPayment]: 'uuid',
  [EnumMultiLanguageType.SalesChannelDiscountsGiftPurchase]: 'discountUuid',
  [EnumMultiLanguageType.SalesChannelDiscountsDirectDiscount]: 'discountUuid',
  [EnumMultiLanguageType.SalesChannelDiscountsSubscriptionBuy]: 'discountUuid',
  [EnumMultiLanguageType.SalesChannelSettingsLogistics]: 'uuid',
  [EnumMultiLanguageType.SalesChannelDiscountsVoucher]: 'discountUuid',
  [EnumMultiLanguageType.SalesChannelProductPromotionTag]: 'tagUuid',
};

const isCurrentPrimary = () => {
  const state = getState();
  const res = isPrimaryLanguage()(state);
  return res;
};

import {
  useQueryLanguageListContentEditor,
  useGetPageLanguageList,
  EnumAction,
  eForceUpdate,
} from './hooks';
export {
  useGetPageLanguageList,
  useQueryLanguageListContentEditor,
  EnumAction,
  isCurrentPrimary,
  EnumMultiLanguageType,
  urlParamsKey,
  eForceUpdate,
};
